<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<ng-container *ngIf="viewModules$ | async as vm">
<div *ngIf="!loading" class="flex flex-col h-full">

    <!-- FILTROS -->
    <div class="flex flex-col gap-4 mb-6">
        <!-- Filtros de data -->
        <div class="w-full">
            <!-- Datas + Filtrar/Limpar: em mobile empilhado, lg na mesma linha -->
            <div class="flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-4">
                <!-- Datas: em mobile 1 col, sm+ 2 cols -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div class="flex items-center gap-2">
                        <label for="initialDate" class="text-sm font-medium text-westetics-neutral-700 whitespace-nowrap">De:</label>
                        <input 
                            type="date" 
                            id="initialDate" 
                            [(ngModel)]="initialDate" 
                            class="bg-white border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-westetics-purple-500 focus:border-transparent w-full"
                        />
                    </div>
                    <div class="flex items-center gap-2">
                        <label for="finalDate" class="text-sm font-medium text-westetics-neutral-700 whitespace-nowrap">Até:</label>
                        <input 
                            type="date" 
                            id="finalDate" 
                            [(ngModel)]="finalDate" 
                            class="bg-white border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-westetics-purple-500 focus:border-transparent w-full"
                        />
                    </div>
                </div>
                <!-- Botões Filtrar/Limpar -->
                <div class="flex flex-col sm:flex-row gap-2 sm:justify-center sm:items-center lg:justify-start">
                    <button 
                        (click)="onDateChange()"
                        class="py-2 px-4 rounded-lg font-medium text-sm bg-westetics-purple-800 text-white hover:bg-westetics-purple-700 transition-colors w-full sm:w-48 lg:w-auto"
                    >
                        Filtrar
                    </button>
                    <button 
                        *ngIf="initialDate || finalDate" 
                        (click)="clearDateFilters()"
                        class="py-2 px-4 rounded-lg font-medium text-sm border border-westetics-purple-800 text-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white transition-colors w-full sm:w-32 lg:w-auto"
                    >
                        Limpar
                    </button>
                </div>
            </div>
        </div>

        <!-- Botões de filtro por status -->
        <div class="flex flex-wrap gap-2 justify-center sm:justify-start">
            <button 
                (click)="changeFilter('PENDING_PATIENT_SIGNATURE')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'PENDING_PATIENT_SIGNATURE',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'PENDING_PATIENT_SIGNATURE'
                }"
                [title]="'Contratos aguardando assinatura - ' + vm.moduleNameInSingular + ' (PENDING e SIGNED_ONLY_BY_RESPONSIBLE)'"
            >
                Pendentes {{vm.moduleNameInSingular}}
            </button>
            <button 
                (click)="changeFilter('NOT_COMPLETED')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'NOT_COMPLETED',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'NOT_COMPLETED'
                }"
            >
                Pendentes
            </button>
            <button 
                (click)="changeFilter('COMPLETED')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'COMPLETED',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'COMPLETED'
                }"
            >
                Assinados
            </button>
            <button 
                (click)="changeFilter('ALL')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'ALL',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'ALL'
                }"
            >
                Todos
            </button>
        </div>
    </div>

    <!-- TABELA DESKTOP -->
    <div class="hidden md:block relative overflow-x-auto rounded-lg flex-1">
        <table class="w-full text-sm text-left text-gray-500 mb-8">
            <thead class="px-2 text-xs text-white bg-westetics-purple-300 mb-2">
                <tr class="text-left">
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm ">
                        Dt. Envio
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm ">
                        {{vm.moduleNameInSingular}}
                    </th>
                    <th *ngIf="vm.moduleName === 'PACIENTES'" scope="col" class="px-5 py-2 font-medium text-nowrap text-sm  ">
                        Procedimento
                    </th>
                    <th *ngIf="vm.moduleName === 'PACIENTES'" scope="col" class="px-5 py-2 font-medium text-nowrap text-sm ">
                        Profissional
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm  ">
                        Total
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm ">
                        Contratos
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm  ">
                        Status
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm ">
                        Ações
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let document of contracts" class="border-b hover:bg-gray-50">
                    <td class="p-4 text-sm text-westetics-neutral-950 ">
                        {{ document.answered_at | date: 'dd/MM/yyyy' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950   text-nowrap">
                        {{ document.patient_name || '-' }}
                    </td>
                        <td *ngIf="vm.moduleName === 'PACIENTES'" class="p-4 text-sm text-westetics-neutral-950  text-nowrap" [title]="document.procedure_name">
                            {{ truncateContractName(document.procedure_name, 30) }}
                        </td>
                    <td *ngIf="vm.moduleName === 'PACIENTES'" class="p-4 text-sm text-westetics-neutral-950 ">
                        {{ formatProfessionalShort(document.professional_name) }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950 ">
                        {{ document.total_value && +document.total_value !== 0 ? (document.total_value | currency:'BRL':'symbol':'1.2-2') : '-' }}
                    </td>
                    <td class="p-4 text-sm ">
                        <div *ngFor="let contract of document.autentique_info_list" class="mb-1 last:mb-0 text-nowrap">
                            <a 
                                (click)="openContract(contract.document_id, getContractStatus(contract.status).message)"
                                class="text-westetics-purple-800 hover:text-westetics-purple-900 cursor-pointer flex items-center gap-1"
                                [title]="contract.document_name"
                            >
                                {{ truncateContractName(contract.document_name, 20) }}
                                <fa-icon [icon]="faExternalLinkAlt" class="text-xs"></fa-icon>
                            </a>
                        </div>
                    </td>
                    <td class="p-4 text-sm ">
                        <div *ngFor="let contract of document.autentique_info_list" class="mb-1 last:mb-0 text-nowrap">
                            <span 
                                class="flex items-center gap-1"
                                [ngClass]="getContractStatus(contract.status).color"
                            >
                                <fa-icon 
                                    *ngIf="contract.status !== 'SIGNED'" 
                                    [icon]="faWarning" 
                                    class="text-xs"
                                ></fa-icon>
                                {{ getContractStatus(contract.status).message }}
                            </span>
                        </div>
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950 ">
                        <div class="flex justify-center gap-1">
                            <button 
                                *ngIf="hasAnyPendingDocument(document)"
                                (click)="openResendModal(document.answer_group_id)"
                                [disabled]="resendLoading === document.answer_group_id"
                                class="p-2 rounded-lg text-westetics-purple-800 hover:text-westetics-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                title="Reenviar lembrete de assinatura"
                            >
                                <fa-icon *ngIf="resendLoading !== document.answer_group_id" [icon]="faPaperPlane"></fa-icon>
                                <app-loading-spinner *ngIf="resendLoading === document.answer_group_id" size="xs"></app-loading-spinner>
                            </button>
                            <!-- Delete Button - Only show for Pendentes Paciente, Pendentes, Todas -->
                            <div *ngIf="filterType !== 'COMPLETED'" class="relative"
                                 (mouseenter)="!canDeleteDocument(document) && showLockTooltip($event, document.answer_group_id)"
                                 (mouseleave)="hideLockTooltip()">
                                <button
                                    class="p-2 rounded-lg hover:bg-gray-100 text-westetics-purple-800 hover:text-westetics-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                    (click)="deleteDocument(document.answer_group_id)"
                                    [disabled]="!canDeleteDocument(document)"
                                    aria-label="Excluir documento"
                                    title="Excluir documento"
                                >
                                    <fa-icon [icon]="faTrash"></fa-icon>
                                </button>
                                <!-- Lock Tooltip -->
                                <div *ngIf="lockTooltipVisibleFor === document.answer_group_id"
                                     [ngStyle]="{ position: 'fixed', left: lockTooltipLeft + 'px', top: lockTooltipTop + 'px', transform: 'translateX(-100%)' }">
                                    <div class="bg-gray-800 text-white text-xs rounded px-2 py-1 flex items-center gap-2 whitespace-nowrap shadow-lg">
                                        <fa-icon [icon]="faLock" class="w-3 h-3"></fa-icon>
                                        <span>{{vm.moduleNameInSingular}} já assinou</span>
                                    </div>
                                </div>
                            </div>
                            <span *ngIf="!hasAnyPendingDocument(document) && filterType === 'COMPLETED'" class="text-gray-400 text-xs">-</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Mensagem quando não há contratos -->
        <div *ngIf="contracts.length === 0 && !loading" class="text-center py-8 text-westetics-neutral-600">
            Nenhuma assinatura encontrada.
        </div>
    </div>

    <!-- CARDS MOBILE -->
    <div class="md:hidden space-y-3 mb-6 flex-1">
        <div *ngFor="let document of contracts" 
             class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow">
            <div class="flex justify-between items-start mb-3">
                <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-westetics-neutral-950 truncate">{{ document.patient_name || '-' }}</h3>
                    <p class="text-xs text-westetics-neutral-600">{{ document.answered_at | date: 'dd/MM/yyyy' }}</p>
                </div>
                <div class="flex items-center gap-1">
                    <button 
                        *ngIf="hasAnyPendingDocument(document)"
                        (click)="openResendModal(document.answer_group_id)"
                        [disabled]="resendLoading === document.answer_group_id"
                        class="p-2 rounded-lg hover:bg-westetics-purple-100 text-westetics-purple-800 hover:text-westetics-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Reenviar lembrete de assinatura"
                    >
                        <fa-icon *ngIf="resendLoading !== document.answer_group_id" [icon]="faPaperPlane"></fa-icon>
                        <app-loading-spinner *ngIf="resendLoading === document.answer_group_id" size="xs"></app-loading-spinner>
                    </button>
                    <!-- Delete Button Mobile - Only show for Pendentes Paciente, Pendentes, Todas -->
                    <button 
                        *ngIf="filterType !== 'COMPLETED'"
                        class="p-2 rounded-lg hover:bg-gray-100 text-westetics-purple-800 hover:text-westetics-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        (click)="deleteDocument(document.answer_group_id)"
                        [disabled]="!canDeleteDocument(document)"
                        aria-label="Excluir documento"
                        title="Excluir documento"
                    >
                        <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                </div>
            </div>
                    <div class="grid grid-cols-2 gap-2 text-xs mb-3" *ngIf="vm.moduleName === 'PACIENTES'">
                <div>
                    <span class="text-westetics-neutral-500">Procedimento:</span>
                    <span class="ml-1 text-westetics-neutral-900" [title]="document.procedure_name">{{ truncateContractName(document.procedure_name, 30) }}</span>
                </div>
                <div>
                    <span class="text-westetics-neutral-500">Profissional:</span>
                        <span class="ml-1 text-westetics-neutral-900">{{ formatProfessionalShort(document.professional_name) }}</span>
                </div>
            </div>
            <div class="text-xs mb-3">
                <span class="text-westetics-neutral-500">Valor:</span>
                <span class="ml-1 text-westetics-purple-800 font-medium">{{ document.total_value && +document.total_value !== 0 ? (document.total_value | currency:'BRL':'symbol':'1.2-2') : '-' }}</span>
            </div>
            <!-- Contratos -->
            <div class="border-t pt-2">
                <p class="text-xs text-westetics-neutral-500 mb-2">Contratos:</p>
                <div *ngFor="let contract of document.autentique_info_list" class="flex justify-between items-center mb-1 last:mb-0">
                    <a 
                        (click)="openContract(contract.document_id, getContractStatus(contract.status).message)"
                        class="text-xs text-westetics-purple-800 hover:text-westetics-purple-900 cursor-pointer flex items-center gap-1 truncate flex-1"
                        [title]="contract.document_name"
                    >
                        {{ truncateContractName(contract.document_name, 20) }}
                        <fa-icon [icon]="faExternalLinkAlt" class="text-[10px]"></fa-icon>
                    </a>
                    <span 
                        class="text-xs flex items-center gap-1 ml-2"
                        [ngClass]="getContractStatus(contract.status).color"
                    >
                        <fa-icon 
                            *ngIf="contract.status !== 'SIGNED'" 
                            [icon]="faWarning" 
                            class="text-[10px]"
                        ></fa-icon>
                        {{ getContractStatus(contract.status).message }}
                    </span>
                </div>
            </div>
        </div>

        <!-- Mensagem quando não há contratos -->
        <div *ngIf="contracts.length === 0 && !loading" class="text-center py-8 text-westetics-neutral-600">
            Nenhuma assinatura encontrada.
        </div>
    </div>

    <!-- PAGINADOR -->
    <div *ngIf="contracts.length > 0" class="flex flex-col lg:flex-row items-center justify-between gap-3 py-4 px-3 lg:px-5">
        <!-- Info de resultados -->
        <div class="text-xs lg:text-sm text-gray-600 order-3 lg:order-1">
            Mostrando {{ currentPage * pageSize + 1 }} - {{ Math.min((currentPage + 1) * pageSize, totalElements) }} de {{ totalElements }} assinaturas
        </div>

        <!-- Controles de paginação -->
        <div class="flex items-center gap-1 lg:gap-2 order-1 lg:order-2">
            <!-- Botão Anterior -->
            <button (click)="goToPreviousPage()" 
                    [disabled]="currentPage === 0"
                    [ngClass]="{'opacity-50 cursor-not-allowed': currentPage === 0}"
                    class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
            </button>
            
            <!-- Números das páginas -->
            <div class="flex items-center gap-1">
                <button *ngFor="let page of generatePagination(currentPage + 1, totalPages)"
                        (click)="navigateTo(page)"
                        [disabled]="page === '...'"
                        [ngClass]="{
                            'bg-westetics-purple-600 text-white': page === currentPage + 1,
                            'hover:bg-gray-50': page !== currentPage + 1 && page !== '...',
                            'cursor-default': page === '...'
                        }"
                        class="min-w-[32px] lg:min-w-[36px] px-2 lg:px-3 py-1.5 lg:py-2 border border-gray-300 rounded-md transition-colors text-xs lg:text-sm">
                    {{ page }}
                </button>
            </div>
            
            <!-- Botão Próximo -->
            <button (click)="goToNextPage()" 
                    [disabled]="currentPage + 1 >= totalPages"
                    [ngClass]="{'opacity-50 cursor-not-allowed': currentPage + 1 >= totalPages}"
                    class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
            </button>
        </div>

        <!-- Seletor de itens por página -->
        <div class="flex items-center gap-2 text-xs lg:text-sm order-2 lg:order-3">
            <span class="text-gray-600">Por página:</span>
            <select [value]="pageSize" (change)="changePageSize($event)"
                    class="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-500">
                <option *ngFor="let opt of pageSizeOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
        </div>
    </div>
</div>

<!-- MODAL DE REENVIO -->
<div 
    *ngIf="showResendModal" 
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    (click)="closeResendModal()"
>
    <div 
        class="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 max-h-[80vh] overflow-y-auto"
        (click)="$event.stopPropagation()"
    >
        <!-- Header -->
        <div class="flex items-center justify-between p-4 border-b">
            <h3 class="text-lg font-semibold text-westetics-neutral-950">Reenviar Links de Assinatura</h3>
            <button 
                (click)="closeResendModal()"
                class="p-1 hover:bg-gray-100 rounded transition-colors"
            >
                <fa-icon [icon]="faTimes" class="text-gray-500"></fa-icon>
            </button>
        </div>

        <!-- Content -->
        <div class="p-4">
            <!-- Loading -->
            <div *ngIf="resendModalLoading" class="flex justify-center py-8">
                <app-loading-spinner size="md"></app-loading-spinner>
            </div>

            <!-- Error -->
            <div *ngIf="resendError" class="bg-red-50 text-red-700 p-4 rounded-lg">
                {{ resendError }}
            </div>

            <!-- Documents List -->
            <div *ngIf="resendDocumentsData && !resendModalLoading">
                <p class="text-sm text-westetics-neutral-600 mb-4">
                    <fa-icon [icon]="faInfoCircle" class="mr-1"></fa-icon>
                    Copie o(s) link(s) abaixo e envie para o {{vm.moduleNameInSingular | lowercase}} assinar os documentos.
                </p>

                <div class="space-y-3 mb-4">
                    <div 
                        *ngFor="let doc of resendDocumentsData.documents" 
                        class="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
                    >
                        <div class="flex-1 min-w-0">
                            <p class="font-medium text-sm text-westetics-neutral-950 truncate">{{ doc.document_name }}</p>
                            <p class="text-xs text-gray-500 truncate">{{ doc.signature_url }}</p>
                        </div>
                        <button 
                            (click)="copyLink(doc.signature_url)"
                            class="ml-3 p-2 hover:bg-gray-200 rounded transition-colors"
                            title="Copiar link"
                        >
                            <fa-icon [icon]="faCopy" class="text-westetics-purple-800"></fa-icon>
                        </button>
                    </div>
                </div>

                <!-- Copy All Button -->
                <button 
                    (click)="copyWhatsAppMessage()"
                    class="w-full py-3 px-4 bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 transition-colors font-medium flex items-center justify-center gap-2"
                >
                    <fa-icon [icon]="faCopy"></fa-icon>
                    Copiar mensagem para WhatsApp
                </button>
            </div>
        </div>
    </div>
</div>



<!-- MODAL DE CONFIRMAÇÃO DE EXCLUSÃO DE DOCUMENTO -->
<div *ngIf="showConfirmDeletePopup" 
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    (click)="!confirmDeleteLoading && closeDeleteModal()">
    <div class="bg-white rounded-lg p-6 w-[480px] max-w-[95vw] shadow-lg mx-4" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center mb-4">
            <h2 class="font-bold text-lg text-westetics-neutral-950">Confirmar exclusão</h2>
            <button (click)="closeDeleteModal()" 
                [disabled]="confirmDeleteLoading"
                class="text-westetics-neutral-600 hover:text-westetics-neutral-900 disabled:opacity-50 disabled:cursor-not-allowed">
                <fa-icon [icon]="faTimes"></fa-icon>
            </button>
        </div>
        <p class="text-base font-medium text-westetics-neutral-950 mb-2">Confirmar exclusão</p>
        <p class="text-sm text-westetics-neutral-800 mb-6">
            Tem certeza que deseja excluir este documento? Esta ação não pode ser desfeita.
        </p>
        <div class="flex justify-end gap-3">
            <button id="confirm-delete-cancel-btn" (click)="closeDeleteModal()"
                [disabled]="confirmDeleteLoading"
                class="px-4 py-2 text-sm font-medium rounded-lg text-westetics-purple-800 hover:bg-westetics-purple-800 border-westetics-purple-800 border hover:text-white disabled:opacity-50 disabled:cursor-not-allowed">
                Cancelar
            </button>
            <button (click)="confirmDelete()"
                [disabled]="confirmDeleteLoading"
                class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-300 disabled:opacity-50 disabled:cursor-not-allowed">
                <ng-container *ngIf="!confirmDeleteLoading">Excluir</ng-container>
                <div *ngIf="confirmDeleteLoading" class="flex items-center gap-2">
                    <app-loading-spinner size="xs"></app-loading-spinner>
                    <span>Excluindo...</span>
                </div>
            </button>
        </div>
    </div>
</div>
</ng-container>
